import './Amenities.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

const Amenities = () => {
  return (
    <div data-aos="fade-up"
      data-aos-duration="1000">
      <div className='amenities-top'>
        <h3>AMENITIES AT A GLANCE</h3>
      </div>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide><img src="./SquarePhotos/Amenities/1.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/2.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/3.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/4.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/5.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/6.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/7.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/8.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/9.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/10.jpeg" alt="AenitiesPics" /></SwiperSlide>
        <SwiperSlide><img src="./SquarePhotos/Amenities/11.jpeg" alt="AenitiesPics" /></SwiperSlide>
      </Swiper>
    </div>
  )
}

export default Amenities










